import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import agentConfigs from './agentConfigs';

function ProjectPage() {
  const { project_id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [instructions, setInstructions] = useState('');
  const [instructionsSaved, setInstructionsSaved] = useState(false);
  const [savingInstructions, setSavingInstructions] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const instructionsTimeout = useRef(null);
  const [projectFiles, setProjectFiles] = useState([]);
  const [uploadingFile, setUploadingFile] = useState(false);
  const isAdmin = localStorage.getItem('is_admin') === 'true';
  const availableAgents = agentConfigs.filter(a => !a.adminOnly || isAdmin);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingFile(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch(`https://hubdaive.com.br/api/projects/${project_id}/files`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const created = await res.json();
      setProjectFiles(prev => [...prev, created]);
    } catch (err) {
      console.error('Erro ao enviar arquivo:', err);
    } finally {
      setUploadingFile(false);
      e.target.value = '';
    }
  };

  const handleDeleteFile = async (fileId) => {
    const token = localStorage.getItem('token');
    try {
      await fetch(`https://hubdaive.com.br/api/projects/${project_id}/files/${fileId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setProjectFiles(prev => prev.filter(f => f.id !== fileId));
    } catch (err) {
      console.error('Erro ao deletar arquivo:', err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      try {
        const [projectRes, threadsRes, filesRes] = await Promise.all([
          fetch(`https://hubdaive.com.br/api/projects/${project_id}`, { headers: { 'Authorization': `Bearer ${token}` } }),
          fetch(`https://hubdaive.com.br/api/projects/${project_id}/threads`, { headers: { 'Authorization': `Bearer ${token}` } }),
          fetch(`https://hubdaive.com.br/api/projects/${project_id}/files`, { headers: { 'Authorization': `Bearer ${token}` } })
        ]);
        const projectData = await projectRes.json();
        const threadsData = await threadsRes.json();
        const filesData   = await filesRes.json();
        console.log('project data:', projectData);
        setProject(projectData);
        setInstructions(projectData.instructions || '');
        setThreads(Array.isArray(threadsData) ? threadsData : []);
        setProjectFiles(Array.isArray(filesData) ? filesData : []);
      } catch (err) {
        console.error('Erro ao carregar projeto:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [project_id]);

  const handleInstructionsChange = (value) => {
    setInstructions(value);
    setInstructionsSaved(false);
    if (instructionsTimeout.current) clearTimeout(instructionsTimeout.current);
    instructionsTimeout.current = setTimeout(async () => {
      setSavingInstructions(true);
      const token = localStorage.getItem('token');
      try {
        await fetch(`https://hubdaive.com.br/api/projects/${project_id}`, {
          method: 'PATCH',
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ instructions: value })
        });
        setInstructionsSaved(true);
      } catch (err) {
        console.error('Erro ao salvar instruções:', err);
      } finally {
        setSavingInstructions(false);
      }
    }, 1000);
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#444', fontSize: '1.5vh' }}>Carregando projeto...</div>
    </div>
  );

  if (!project) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#444', fontSize: '1.5vh' }}>Projeto não encontrado.</div>
    </div>
  );

  return (
    
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', fontFamily: 'Helvetica, Arial, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .thread-row:hover { background-color: #141414 !important; }
        .thread-row:hover .thread-arrow { opacity: 1 !important; }
        .agent-card:hover { transform: translateY(-2px); border-color: var(--agent-color) !important; }

        /* MOBILE */
        @media (max-width: 767px) {
          .project-body { flex-direction: column !important; overflow: visible !important; }
          .project-left { border-right: none !important; border-bottom: 1px solid #1a1a1a !important; }
          .project-right { width: 100% !important; }
          .project-header { flex-direction: column !important; align-items: flex-start !important; gap: 8px;  }
          .project-spacing { margin-left : 8vw !important; }
      `}</style>

      {/* Header */}
      <div className="project-header" style={{ padding: '3vh 4vw 2vh', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'space-between', animation: 'fadeInUp 0.3s ease both' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <button className="project-spacing" onClick={() => navigate('/home')} style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '1.8vh', padding: 0, textAlign: 'left', marginBottom: '4px'}}
            onMouseEnter={e => e.currentTarget.style.color = '#888'} onMouseLeave={e => e.currentTarget.style.color = '#444'}>
            ← Voltar
          </button>
          <h1 className="project-spacing" style={{ color: '#fff', fontSize: '2.8vh', fontWeight: '700', margin: 0 }}>{project.name}</h1>
          {project.description && <p style={{ color: '#555', fontSize: '2vh', marginTop: '0.5vh' }}>{project.description}</p>}
        </div>
      </div>

      {/* Corpo */}
      <div className="project-body" style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* Esquerda */}
        <div className="project-left" style={{ flex: 1, padding: '3vh 4vw', overflowY: 'auto', borderRight: '1px solid #1a1a1a' }}>

          {/* ✅ Seletor de agente */}
          <p style={{ color: '#555', fontSize: '1.8vh', marginBottom: '1.5vh', fontWeight: '600', letterSpacing: '1px' }}>INICIAR COM</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '3vh' }}>
            {availableAgents.map(agent => (
              <div
                key={agent.key}
                className="agent-card"
                onClick={() => setSelectedAgent(selectedAgent?.key === agent.key ? null : agent)}
                style={{
                  '--agent-color': agent.color,
                  backgroundColor: selectedAgent?.key === agent.key ? agent.color + '18' : '#0d0d0d',
                  border: `1px solid ${selectedAgent?.key === agent.key ? agent.color + '88' : '#1a1a1a'}`,
                  borderRadius: '10px',
                  padding: '12px 18px',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: agent.color, flexShrink: 0 }} />
                <span style={{ color: selectedAgent?.key === agent.key ? agent.color : '#888', fontSize: '1.8vh', fontWeight: '500' }}>{agent.name}</span>
              </div>
            ))}
          </div>

          {/* Botão nova conversa */}
          <button
            onClick={() => {
              if (!selectedAgent) return;
              const url = `/chat/${selectedAgent.key}?project_id=${project_id}&new_thread=true`;
              console.log('navegando para:', url, 'agente:', selectedAgent);
              navigate(url);
            }}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: selectedAgent ? selectedAgent.color + '18' : 'transparent',
              border: `1px dashed ${selectedAgent ? selectedAgent.color + '66' : '#333'}`,
              borderRadius: '12px',
              color: selectedAgent ? selectedAgent.color : '#444',
              fontSize: '2vh',
              fontWeight: '600',
              cursor: selectedAgent ? 'pointer' : 'not-allowed',
              marginBottom: '3vh',
              transition: 'all 0.15s',
              opacity: selectedAgent ? 1 : 0.5
            }}
          >
            {selectedAgent ? `+ Nova Conversa com ${selectedAgent.name}` : 'Selecione um agente acima'}
          </button>

          {/* Lista de conversas */}
          <p style={{ color: '#555', fontSize: '1.8vh', marginBottom: '1.5vh', fontWeight: '600', letterSpacing: '1px' }}>CONVERSAS</p>
          {threads.length === 0 ? (
            <div style={{ backgroundColor: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '12px', padding: '3vh', textAlign: 'center', color: '#333', fontSize: '2vh' }}>
              Inicie uma conversa para organizar e reutilizar o conhecimento do projeto.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {threads.map((thread, i) => (
                <div
                  key={thread.thread_id}
                  className="thread-row"
                  onClick={() => navigate(`/chat/${thread.agent_type || project.agent_type || 'briefador'}?thread_id=${thread.thread_id}&project_id=${project_id}`)}
                  style={{ backgroundColor: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '10px', padding: '14px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'background 0.15s', animation: `fadeInUp 0.3s ease ${i * 0.04}s both` }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: agentConfigs.find(a => a.key === thread.agent_type)?.color || '#007AFF', flexShrink: 0 }} />
                    <span style={{ color: '#ccc', fontSize: '2vh', fontWeight: '500' }}>{thread.title || 'Conversa sem título'}</span>
                  </div>
                  <span className="thread-arrow" style={{ color: '#444', fontSize: '2vh', opacity: 0, transition: 'opacity 0.15s' }}>→</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Direita */}
        <div className="project-right" style={{ width: '35vw', flexShrink: 0, padding: '3vh 2vw', display: 'flex', flexDirection: 'column', gap: '2vh', overflowY: 'auto' }}>
          {/* Instruções */}
          <div style={{ backgroundColor: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '12px', padding: '18px', animation: 'fadeInUp 0.3s ease 0.1s both' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <span style={{ color: '#fff', fontSize: '2.5vh', fontWeight: '600' }}>Instruções Específicas:</span>
              {savingInstructions && <span style={{ color: '#444', fontSize: '2vh' }}>Salvando...</span>}
              {instructionsSaved && !savingInstructions && <span style={{ color: '#555', fontSize: '2vh' }}>Salvo ✓</span>}
            </div>
            <textarea value={instructions} onChange={e => handleInstructionsChange(e.target.value)}
              placeholder="Adicionar instruções para personalizar as respostas do agente neste projeto..."
              style={{ width: '100%', minHeight: '120px', backgroundColor: '#141414', border: '1px solid #222', borderRadius: '8px', padding: '10px', color: '#ccc', fontSize: '1.8vh', resize: 'vertical', outline: 'none', fontFamily: 'Helvetica, Arial, sans-serif', lineHeight: '1.8', boxSizing: 'border-box' }}
              onFocus={e => e.target.style.borderColor = '#444'}
              onBlur={async (e) => {
                e.target.style.borderColor = '#222';
                const token = localStorage.getItem('token');
                await fetch(`https://hubdaive.com.br/api/projects/${project_id}`, { method: 'PATCH', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ instructions }) });
              }}
            />
          </div>

          {/* Arquivos */}
          <div style={{ backgroundColor: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '12px', padding: '18px', animation: 'fadeInUp 0.3s ease 0.15s both' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <span style={{ color: '#fff', fontSize: '2.5vh', fontWeight: '600' }}>Base de Conhecimento:</span>
              <label style={{ color: '#007AFF', fontSize: '2vh', cursor: 'pointer' }}>
                +
                <input type="file" accept=".pdf,.docx,.txt,.xlsx,.xls,.mp3" style={{ display: 'none' }} onChange={handleFileUpload} />
              </label>
            </div>
            {uploadingFile && <div style={{ color: '#555', fontSize: '2vh', marginBottom: '10px' }}>Enviando...</div>}
            {projectFiles.length === 0 && !uploadingFile ? (
              <div style={{ border: '1px dashed #1e1e1e', borderRadius: '8px', padding: '2vh', textAlign: 'center', color: '#333', fontSize: '2vh', lineHeight: '1.6' }}>
                Adicione PDFs, documentos ou outros textos para usar como referência neste projeto.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {projectFiles.map(f => (
                  <div key={f.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#141414', borderRadius: '8px', padding: '8px 12px', border: '1px solid #1e1e1e' }}>
                    <span style={{ color: '#ccc', fontSize: '1.8vh', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{f.original_name}</span>
                    <span onClick={() => handleDeleteFile(f.id)} style={{ color: '#333', fontSize: '1.2vh', cursor: 'pointer', marginLeft: '8px', flexShrink: 0 }}
                      onMouseEnter={e => e.currentTarget.style.color = '#ff4444'} onMouseLeave={e => e.currentTarget.style.color = '#333'}>✕</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectPage;